import { ClickerGroup } from '@gr/shared/entities';
import { IHttpResponse } from '@gr/shared/models';
import { useQuery } from '@tanstack/react-query';
import { axiosPost } from '../authAxios';

interface IUseClickerGroupsOptions {
  enabled?: boolean;
}

export default function useClickerGroups({ enabled = true }: IUseClickerGroupsOptions = {}) {
  return useQuery({
    queryKey: ['clicker-groups'],
    queryFn: async () => {
      const axios = await axiosPost<IHttpResponse<ClickerGroup[]>>('clicker-groups-get');
      return axios.data?.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}
